module.exports = __webpack_public_path__ + "static/media/autumn-soups.c9b910d0.jpeg";